module.exports = __webpack_public_path__ + "img/dried-meat.e45e0fac.webp";